import React, { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

const TemplateSidebar = ({ data, tagTitle }) => {
  const [showAllTags, setShowAllTags] = useState(false);
  const [clickSet, setClickSet] = useState("Click me");
  const [customTag, setCustomTag] = useState([]);
  const url = typeof window !== "undefined" ? window?.location?.pathname : "";

  let tagsToConsider = ["field_theme", "field_region", "field_country"];

  const handleTags = (tag) => {
    let allTags = [];
    for (let t in tag) {
      if (tagsToConsider?.includes(t)) {
        if (tag?.[t]?.length > 0) {
          allTags = [...allTags, ...tag?.[t]];
        }
        if (t === "field_region" && tag?.[t] !== null) {
          allTags?.push(tag?.[t]);
        }
      }
    }
    setCustomTag(allTags);
  };
  const topRef = useRef(null);

  const scrollToTop = () => {
    topRef.current.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    handleTags(data?.relationships);
  }, []);

  return (
    <Container className="general-container w-auto p-0" ref={topRef}>
      <div className="ct-container-hero-box-r">
        <div>
          <div className="hr"></div>
          <div className="share-icons">
            <span className="">Share</span>
            <LinkedinShareButton
              title={data?.title}
              url={`${process.env.GATSBY_URL}${url}`}
            >
              <img loading="lazy" src="/linkedin.svg" alt="LinkedIn" />
            </LinkedinShareButton>
            <TwitterShareButton
              title={data?.title}
              url={`${process.env.GATSBY_URL}${url}`}
            >
              <img loading="lazy" src="/twitterx.svg" alt="Twitter" />
            </TwitterShareButton>
            <FacebookShareButton
              title={data?.title}
              url={`${process.env.GATSBY_URL}${url}`}
            >
              <img loading="lazy" src="/facebook.svg" alt="Facebook" />
            </FacebookShareButton>
            <EmailShareButton
              subject={data?.title}
              url={`${process.env.GATSBY_URL}${url}`}
            >
              <img loading="lazy" src="/mail.svg" alt="Email" />
            </EmailShareButton>
            <OverlayTrigger overlay={<Tooltip>{clickSet}</Tooltip>}>
              <div
                className="react-share__ShareButton"
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === "Space") {
                    navigator?.clipboard?.writeText(
                      `${process.env.GATSBY_URL}${window?.location?.pathname}`
                    );
                    setClickSet("Copied!!");
                  }
                }}
                onClick={(e) => {
                  navigator?.clipboard?.writeText(
                    `${process.env.GATSBY_URL}${window?.location?.pathname}`
                  );
                  setClickSet("Copied!!");
                }}
              >
                <img loading="lazy" src="/link.svg" alt="Link" />
              </div>
            </OverlayTrigger>
          </div>
          <div className="hr"></div>
        </div>
        {data?.relationships?.field_sidebar?.field_links?.length > 0 && (
          <div className="quick-nav">
            <div className="quick-nav-title">
              {data?.relationships?.field_sidebar?.field_component_title}
            </div>
            <div>
              <ul className="quick-nav">
                {data?.relationships?.field_sidebar?.field_links?.map(
                  (item, key) => {
                    return (
                      <li key={key} className="quick-nav-list">
                        <a
                          href={item?.url ? item?.url : ""}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.title}
                        </a>
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
            <div className="hr"></div>
          </div>
        )}
        {customTag?.length > 0 && (
          <div>
            <h6 className="tags-title">{tagTitle}</h6>
            <div className="tags">
              {customTag?.map((item, key) => {
                return (
                  <>
                    {key < 4 && !showAllTags && (
                      <a key={key} href="/search" target="_blank">
                        {item?.name}
                      </a>
                    )}
                    {showAllTags && (
                      <a key={key} href="/search" target="_blank">
                        {item?.name}
                      </a>
                    )}
                  </>
                );
              })}
            </div>
            {customTag?.length > 4 && (
              <div
                role="button"
                tabIndex={0}
                className="tags-view"
                onClick={() => {
                  if (showAllTags) {
                    setShowAllTags(!showAllTags);
                    scrollToTop();
                  } else {
                    setShowAllTags(!showAllTags);
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === "Space") {
                    if (showAllTags) {
                      setShowAllTags(!showAllTags);
                      scrollToTop();
                    } else {
                      setShowAllTags(!showAllTags);
                    }
                  }
                }}
              >
                {showAllTags ? "View fewer topics" : "View all topics"}
                <img
                  loading="lazy"
                  src={"/blue-arrow-underline.svg"}
                  alt="arrow"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Container>
  );
};

export default TemplateSidebar;
